export default "__VITE_ASSET__ChaMQkuc__"